import React from 'react';
import HandleError from '../Error/HandleError';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: '', info: '' };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    const { AppContext } = this.props;
    this.setState({ error, info });
    if (AppContext !== undefined) {
      // (ctx, message, stackTrace, componentState, componentProps, details )
      AppContext.context.logError(AppContext.context, 'An error occured in CTSU Portal Application', info, { ...this.state }, { ...this.props }, error);
    } else {
      // console.log(error, info);
    }
  }

  render() {
    const { hasError, error, info } = this.state;
    const { children } = this.props;
    if (hasError) {
      // You can render any custom fallback UI
      return <HandleError error={error} details={info} />;
    }

    return children;
  }
}

export default ErrorBoundary;
